import { Avatar, InputAdornment, TextField} from "@mui/material";
import Grid from "@mui/material/Grid2";
import dayjs from "dayjs";
import { useMemo } from "react";
import { useSelector } from "react-redux";

interface DcProcessLogsMoreInfoProps {
  runId: string;
}

const inputStyles = {
  "& .MuiInputBase-input": {
    fontSize: "16px",
  },
  "& .MuiInputLabel-root": {
    fontSize: "16px",
  },
  "& .MuiInput-underline:before": {
    borderBottom: "none",
  },
  "& .MuiInput-underline:after": {
    borderBottom: "none",
  },
  "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
    borderBottom: "none",
  },
};

const DcProcessLogsMoreInfo = ({ runId }: DcProcessLogsMoreInfoProps) => {
  const { processLogsList } = useSelector(
    (state: any) => state.monitoringProcessLogs
  );
  
 
  const selectedMoreInfo = useMemo(() => {
    return processLogsList?.find((item: any) => item.run_id === runId);
  }, [processLogsList, runId]);

  const rowData = useMemo(
    () => [
      {
        label: "Report Name",
        id: "1",
        value: selectedMoreInfo?.report_name ? selectedMoreInfo?.report_name :"N/A",
      },
      {
        label: "Config Name",
        id: "2",
        value: selectedMoreInfo?.config_name ? selectedMoreInfo?.config_name :"N/A",
      },
      {
        label: "Raw Data Table",
        id: "3",
        value: selectedMoreInfo?.raw_table_id ? selectedMoreInfo?.raw_table_id :"N/A",
      },
      {
        label: "Destination Table",
        id: "4",
        value: selectedMoreInfo?.destination_table ? selectedMoreInfo?.destination_table :"N/A",
      },
      {
        label: "Created on",
        id: "5",
        value: selectedMoreInfo?.created ? dayjs(selectedMoreInfo?.created).format("DD/MM/YYYY") : "N/A",
      },
      { label: "Created by", id: "6", value: selectedMoreInfo?.run_by },
      { label: "Start Date", id: "7", value:  selectedMoreInfo?.period_start_date ? dayjs(selectedMoreInfo?.period_start_date).format("DD/MM/YYYY"):"N/A" },
      { label: "End Date", id: "8", value: selectedMoreInfo?.period_end_date ? dayjs(selectedMoreInfo?.period_end_date).format("DD/MM/YYYY")  :"N/A" },
    ],
    [selectedMoreInfo]
  );
  

  return (
    <Grid container spacing={2}>
      {rowData.length > 0 &&
        rowData?.map((item: any) => (
          <Grid size={3} key={item.id}>
            <TextField
              color="secondary"
              fullWidth
              label={item.label}
              variant="standard"
              value={item.value ?? ""}
              sx={inputStyles}
              slotProps={{
                inputLabel: {
                  shrink: true,
                },
              }}
              InputProps={{
                readOnly: true,
                startAdornment:
                  item.label === "Created by" && item.value ? (
                    <InputAdornment position="start">
                      <Avatar sx={{ width: 24, height: 24 }}>
                        {item?.value?.charAt(0)}
                      </Avatar>
                    </InputAdornment>
                  ) : null,
              }}
            />
          </Grid>
        ))}
    </Grid>
  );
};

export default DcProcessLogsMoreInfo;
